import * as amzMqPush from "./amzMqPush";
import * as amzReportRequestNoticeFacadeImpl from "./amzReportRequestNoticeFacadeImpl";
import * as createReportTaskFacadeImpl from "./createReportTaskFacadeImpl";
import * as monthlyReport from "./monthlyReport";
import * as pauseShopFacadeImpl from "./pauseShopFacadeImpl";
import * as platformReport from "./platformReport";
import * as platformReportFacadeImpl from "./platformReportFacadeImpl";
import * as reportPage from "./reportPage";
import * as test from "./test";

export const platDataFlow = {
  amzMqPush,
  amzReportRequestNoticeFacadeImpl,
  createReportTaskFacadeImpl,
  monthlyReport,
  pauseShopFacadeImpl,
  platformReport,
  platformReportFacadeImpl,
  reportPage,
  test,
};
